//# sourceMappingURL=user.mjs.map
/// <reference types="./user.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $when from "../../../altar/altar/when.mjs";
import * as $promise_ from "../../../altar/gleam/javascript/promise_.mjs";
import * as $connection from "../../../data_types/data/auth/connection.mjs";
import * as $invitation from "../../../data_types/data/auth/invitation.mjs";
import * as $role from "../../../data_types/data/auth/role.mjs";
import * as $user_id from "../../../data_types/data/auth/user_id.mjs";
import * as $wss_connected from "../../../data_types/data/ephemeral/wss_connected.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $html from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $console from "../../../tiamat/gleam/javascript/console.mjs";
import * as $organization from "../../admin/effects/organization.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $user_requests from "../../admin/requests/user.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

/**
 * Ask the API who the caller is. The token names an Auth0 account, while the
 * member list, owners and authors this SPA shows are all keyed by a person.
 */
export function fetch_identity(access_token) {
  return $effect.from(
    (dispatch, _) => {
      let _pipe = $ask.to(new $ask.Heimdall(), toList(["user", "identity"]));
      let _pipe$1 = $ask.via(_pipe, new $http.Get());
      let _pipe$2 = $ask.bearing(_pipe$1, access_token);
      let _pipe$3 = $ask.expect(
        _pipe$2,
        $decode.at(toList(["user_id"]), $user_id.decoder()),
      );
      let _pipe$4 = $ask.on_success(
        _pipe$3,
        (user_id) => {
          return dispatch(new $msg.ApiReturnedUserIdentity(user_id));
        },
      );
      return $ask.run(_pipe$4);
    },
  );
}

export function fetch_roles() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(new $msg.ApiStartedLoadingRoles());
          let _pipe = $ask.to(new $ask.Heimdall(), toList(["roles"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(_pipe$2, $decode.list($role.decoder()));
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (roles) => {
              dispatch(new $msg.ApiReturnedRoles(roles));
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let _pipe$5 = error;
              let _pipe$6 = $string.inspect(_pipe$5);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredRoles(_capture);
              })(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_connections() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(new $msg.ApiStartedLoadingConnections());
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "connections"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($connection.decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (c) => {
              dispatch(new $msg.ApiReturnedConnections(c));
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (error) => {
              let _pipe$5 = error;
              let _pipe$6 = $string.inspect(_pipe$5);
              let _pipe$7 = ((_capture) => {
                return new $msg.ApiErroredConnections(_capture);
              })(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

function inviting_text(current, total) {
  let total$1 = $int.to_string(total);
  let current$1 = $int.to_string(current + 1);
  let indicator = $string.join(toList([current$1, total$1]), " / ");
  return $string.join(toList(["Inviting users in progress…", indicator]), "\n");
}

export function invite(invitations) {
  return $effect.from_(
    (_, get_state, dispatch_effect) => {
      let store = get_state();
      let organization = $store.current_organization(store);
      let count = $list.length(invitations);
      let _block;
      let _pipe = $toast.default_options();
      let _pipe$1 = $toast.close_manually(_pipe);
      let _pipe$2 = $toast.hide_close_button(_pipe$1);
      _block = $toast.custom(_pipe$2, inviting_text(0, count));
      let toast_id = _block;
      let _pipe$3 = invitations;
      let _pipe$4 = $promise_.index_sequence(
        _pipe$3,
        (invitation, index) => {
          let _pipe$4 = $toast.default_options();
          let _pipe$5 = $toast.render(
            _pipe$4,
            $html.text(inviting_text(index, count)),
          );
          ((_capture) => { return $toast.update(toast_id, _capture); })(_pipe$5);
          return $user_requests.invite(store, invitation);
        },
      );
      return $promise.tap(
        _pipe$4,
        (_) => {
          let _pipe$5 = $toast.default_options();
          let _pipe$6 = $toast.auto_close(_pipe$5);
          let _pipe$7 = $toast.show_close_button(_pipe$6);
          let _pipe$8 = $toast.render(
            _pipe$7,
            $html.text("All invitations sent!"),
          );
          ((_capture) => { return $toast.update(toast_id, _capture); })(_pipe$8);
          return $when.some_(
            organization,
            () => { return undefined; },
            (org) => {
              dispatch_effect($organization.fetch_invitations(org.id));
              return undefined;
            },
          );
        },
      );
    },
  );
}

function assigning_text(current, total) {
  let total$1 = $int.to_string(total);
  let current$1 = $int.to_string(current + 1);
  let indicator = $string.join(toList([current$1, total$1]), " / ");
  return $string.join(toList(["Assigning roles in progress…", indicator]), "\n");
}

export function assign_roles(org_id, user_ids, role_ids) {
  return $effect.from_(
    (_, get_state, dispatch_effect) => {
      let store = get_state();
      let count = $list.length(user_ids);
      let _block;
      let _pipe = $toast.default_options();
      let _pipe$1 = $toast.close_manually(_pipe);
      let _pipe$2 = $toast.hide_close_button(_pipe$1);
      _block = $toast.custom(_pipe$2, assigning_text(0, count));
      let toast_id = _block;
      let _pipe$3 = user_ids;
      let _pipe$4 = $promise_.index_sequence(
        _pipe$3,
        (user_id, index) => {
          let _pipe$4 = $toast.default_options();
          let _pipe$5 = $toast.render(
            _pipe$4,
            $html.text(assigning_text(index, count)),
          );
          ((_capture) => { return $toast.update(toast_id, _capture); })(_pipe$5);
          return $user_requests.assign_roles(store, org_id, user_id, role_ids);
        },
      );
      return $promise.tap(
        _pipe$4,
        (_) => {
          let _pipe$5 = $toast.default_options();
          let _pipe$6 = $toast.auto_close(_pipe$5);
          let _pipe$7 = $toast.show_close_button(_pipe$6);
          let _pipe$8 = $toast.render(
            _pipe$7,
            $html.text("Roles assigned to all selected users!"),
          );
          ((_capture) => { return $toast.update(toast_id, _capture); })(_pipe$8);
          dispatch_effect($organization.fetch_users(org_id));
          return undefined;
        },
      );
    },
  );
}

function removing_text(current, total) {
  let total$1 = $int.to_string(total);
  let current$1 = $int.to_string(current + 1);
  let indicator = $string.join(toList([current$1, total$1]), " / ");
  return $string.join(toList(["Removing roles in progress…", indicator]), "\n");
}

export function remove_roles(org_id, user_ids, role_ids) {
  return $effect.from_(
    (_, get_state, dispatch_effect) => {
      let store = get_state();
      let count = $list.length(user_ids);
      let _block;
      let _pipe = $toast.default_options();
      let _pipe$1 = $toast.close_manually(_pipe);
      let _pipe$2 = $toast.hide_close_button(_pipe$1);
      _block = $toast.custom(_pipe$2, removing_text(0, count));
      let toast_id = _block;
      let _pipe$3 = user_ids;
      let _pipe$4 = $promise_.index_sequence(
        _pipe$3,
        (user_id, index) => {
          let _pipe$4 = $toast.default_options();
          let _pipe$5 = $toast.render(
            _pipe$4,
            $html.text(removing_text(index, count)),
          );
          ((_capture) => { return $toast.update(toast_id, _capture); })(_pipe$5);
          return $user_requests.remove_roles(store, org_id, user_id, role_ids);
        },
      );
      return $promise.tap(
        _pipe$4,
        (_) => {
          let _pipe$5 = $toast.default_options();
          let _pipe$6 = $toast.auto_close(_pipe$5);
          let _pipe$7 = $toast.show_close_button(_pipe$6);
          let _pipe$8 = $toast.render(
            _pipe$7,
            $html.text("Roles removed from all selected users!"),
          );
          ((_capture) => { return $toast.update(toast_id, _capture); })(_pipe$8);
          dispatch_effect($organization.fetch_users(org_id));
          return undefined;
        },
      );
    },
  );
}

export function uninvite(invitation) {
  return $effect.from_(
    (_, get_state, dispatch_effect) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList([
              "admin",
              "organization",
              invitation.org_id,
              "invitation",
              invitation.id,
            ]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (c) => { return $console.log(c); },
          );
          let _pipe$4 = $ask.run(_pipe$3);
          return $promise.tap(
            _pipe$4,
            (_) => {
              return dispatch_effect(
                $organization.fetch_invitations(invitation.org_id),
              );
            },
          );
        },
      );
    },
  );
}

export function fetch_sockets() {
  return $effect.from_(
    (dispatch, get_state, _) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(
            new $msg.Organizations(
              new $msg.ApiReturnedSocketsConnections(new $remote.Loading()),
            ),
          );
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "websockets"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($wss_connected.decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (c) => {
              dispatch(
                new $msg.Organizations(
                  new $msg.ApiReturnedSocketsConnections(new $remote.Loaded(c)),
                ),
              );
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (e) => {
              let _block;
              if (e instanceof $ask.FetchError) {
                _block = "fetch error";
              } else if (e instanceof $ask.DecodeError) {
                _block = "format error";
              } else {
                let reason = e.reason;
                _block = reason;
              }
              let reason = _block;
              dispatch(
                new $msg.Organizations(
                  new $msg.ApiReturnedSocketsConnections(
                    new $remote.Errored(reason),
                  ),
                ),
              );
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}
